import imgGilneiMachado from "../../../../../assets/images/empresa/sobre-nos/diretores/Gilnei-Machado.png";
import imgAlexandreAbdala from "../../../../../assets/images/empresa/sobre-nos/diretores/Alexandre-Abdala.png";
import imgAlexandreBrito from "../../../../../assets/images/empresa/sobre-nos/diretores/Alexandre-Brito.png";
import imgGiovanniAvelar from "../../../../../assets/images/empresa/sobre-nos/diretores/Giovanni-Avelar.png";
import imgJoaoCarlosBarbosa from "../../../../../assets/images/empresa/sobre-nos/diretores/Joao-Carlos-Barbosa.png";
import imgMariaDeLourdesAguiar from "../../../../../assets/images/empresa/sobre-nos/diretores/Maria-de-Lourdes-Aguiar.png";
import imgOctavioCacozzi from "../../../../../assets/images/empresa/sobre-nos/diretores/Octavio-Cacozzi.png";
import imgRenatoMancini from "../../../../../assets/images/empresa/sobre-nos/diretores/Renato-Mancini.png";
import imgRodrigoSousaLima from "../../../../../assets/images/empresa/sobre-nos/diretores/Rodrigo-Sousa-Lima.png";
import { Diretores } from "../../../../../interfaces/Diretores";

const diretores: Diretores[] = [
  { image: imgGilneiMachado, name: 'Gilnei Machado', role: 'Diretor Presidente' },
  { image: imgAlexandreAbdala, name: 'Alexandre Abdala', role: 'Diretor Geral de Operações' },
  { image: imgAlexandreBrito, name: 'Alexandre Brito', role: 'Diretor Operacional MG/ES' },
  { image: imgGiovanniAvelar, name: 'Leonardo Moraes', role: 'Diretor Operacional CO' },
  { image: imgJoaoCarlosBarbosa, name: 'João Carlos Barbosa', role: 'Diretor de TI e Digital' },
  { image: imgMariaDeLourdesAguiar, name: 'Maria de Lourdes Aguiar', role: 'Diretora de Gente e Gestão' },
  { image: imgOctavioCacozzi, name: 'Octavio Cacozzi', role: 'Diretor Operacional SP/SUL' },
  { image: imgRenatoMancini, name: 'Renato Mancini', role: 'Diretor de Energia' },
  { image: imgRodrigoSousaLima, name: 'Rodrigo Sousa Lima', role: 'Diretor Administrativo Financeiro' }
];

export const getDiretoresPorLinha = (): Diretores[][] => {
  const [l1, l2, l3, l4] = [diretores.at(0), diretores.slice(1, 4), diretores.slice(4, 7), diretores.slice(7, 9)];
  return [[l1!], l2, l3, l4];
};

export const getDiretores = (): Diretores[] => diretores;